import { ColorScheme } from "features/CenterContent/RoleContent/EventHandling/components/InfraEventCard/types";
import { FC, ReactNode, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import { DropsButton, tokens, VStack } from "shared/components/Spor";
import { useTheme } from "styled-components";

type EventCardContainerProps = {
  uuid: string;
  children: ReactNode | ((hover: boolean) => ReactNode);
  colorScheme: ColorScheme;
  disabled?: boolean;
};

export const EventCardContainer: FC<EventCardContainerProps> = ({
  uuid,
  children,
  colorScheme,
  disabled = false,
}) => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  return (
    <DropsButton
      // needed as it contains a button as a child
      as="div"
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={() =>
        !disabled &&
        navigate(
          generatePath("/infrastructure-event/:eventId", {
            eventId: uuid,
          }),
        )
      }
      px={tokens.default.size.spacing[2]}
      py={tokens.default.size.spacing[1.5]}
      backgroundColor={colorScheme.backgroundColor}
      border={`1px solid ${colorScheme.borderColor}`}
      borderRadius={tokens.default.size["border-radius"].xs}
      boxShadow={theme.boxShadow}
      _hover={
        disabled
          ? undefined
          : { backgroundColor: colorScheme.backgroundColorHover }
      }
      cursor={disabled ? "default" : "pointer"}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      width="100%"
    >
      <VStack
        alignItems="start"
        gap={tokens.default.size.spacing[2]}
        width="100%"
      >
        {typeof children === "function" ? children(hover) : children}
      </VStack>
    </DropsButton>
  );
};
